export enum RoutesEnum {
    FORBIDDEN = 'error/403',
    ERROR_404 = '**',
}
